import type { LangMap } from "./index";

export const lumen: LangMap = {
  it: {
    name: "Lumen",
    tagline: "La tua stellina di studio",
    level: "Livello {{level}}",
    xpToNext: "{{xp}} XP al livello {{level}}",
    streak: {
      title: "Serie di studio",
      days_one: "{{count}} giorno",
      days_other: "{{count}} giorni",
      todayDone: "Oggi hai già studiato: serie al sicuro!",
      todayPending: "Studia oggi per non perdere la serie.",
      restToday: "Oggi è un giorno di riposo: la serie è protetta.",
      lost: "Serie azzerata. Ricominciamo insieme!",
    },
    rest: {
      title: "Giorni di riposo",
      hint: "Nei giorni scelti la serie non si perde.",
      edit: "Modifica",
      save: "Salva",
      cancel: "Annulla",
      none: "Nessuno",
      saved: "Giorni di riposo aggiornati",
    },
    quests: {
      title: "Sfide di oggi",
      subtitle: "Completa le sfide e guadagna XP",
      claim: "Riscuoti",
      claimed: "Riscosso",
      allDone: "Tutte le sfide completate! Sei una stella.",
      reward: "+{{xp}} XP",
      gained: "+{{xp}} XP guadagnati!",
      keys: {
        study_20: "Studia 20 minuti",
        study_45: "Studia 45 minuti",
        quiz_1: "Completa 1 quiz",
        ask_lumen_3: "Fai 3 domande a Lumen",
        create_1: "Crea 1 contenuto di studio",
        flashcards_deck: "Crea un mazzo di flashcard",
      },
    },
    onboarding: {
      intro: "Ciao! Sono Lumen ✨ Ti faccio qualche domanda per creare il tuo percorso.",
      restTitle: "Quando ti riposi?",
      restSubtitle: "Scegli i giorni liberi: in quei giorni la serie non si perde.",
    },
    tutor: { title: "Parla con Lumen", subtitle: "Il tuo tutor stellina, sempre con te" },
  },
  en: {
    name: "Lumen",
    tagline: "Your little study star",
    level: "Level {{level}}",
    xpToNext: "{{xp}} XP to level {{level}}",
    streak: {
      title: "Study streak",
      days_one: "{{count}} day",
      days_other: "{{count}} days",
      todayDone: "You studied today: streak safe!",
      todayPending: "Study today so you don't lose your streak.",
      restToday: "Today is a rest day: your streak is protected.",
      lost: "Streak reset. Let's start again!",
    },
    rest: {
      title: "Rest days",
      hint: "On the days you pick, the streak can't be lost.",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      none: "None",
      saved: "Rest days updated",
    },
    quests: {
      title: "Today's challenges",
      subtitle: "Complete challenges and earn XP",
      claim: "Claim",
      claimed: "Claimed",
      allDone: "All challenges done! You're a star.",
      reward: "+{{xp}} XP",
      gained: "+{{xp}} XP earned!",
      keys: {
        study_20: "Study for 20 minutes",
        study_45: "Study for 45 minutes",
        quiz_1: "Complete 1 quiz",
        ask_lumen_3: "Ask Lumen 3 questions",
        create_1: "Create 1 study item",
        flashcards_deck: "Create a flashcard deck",
      },
    },
    onboarding: {
      intro: "Hi! I'm Lumen ✨ Let me ask a few questions to build your path.",
      restTitle: "When do you rest?",
      restSubtitle: "Pick your free days: on those days the streak is safe.",
    },
    tutor: { title: "Talk with Lumen", subtitle: "Your star tutor, always with you" },
  },
  es: {
    name: "Lumen",
    tagline: "Tu estrellita de estudio",
    level: "Nivel {{level}}",
    xpToNext: "{{xp}} XP para el nivel {{level}}",
    streak: {
      title: "Racha de estudio",
      days_one: "{{count}} día",
      days_other: "{{count}} días",
      todayDone: "Hoy ya estudiaste: ¡racha a salvo!",
      todayPending: "Estudia hoy para no perder la racha.",
      restToday: "Hoy es día de descanso: tu racha está protegida.",
      lost: "Racha reiniciada. ¡Empecemos de nuevo!",
    },
    rest: {
      title: "Días de descanso",
      hint: "En los días elegidos la racha no se pierde.",
      edit: "Editar",
      save: "Guardar",
      cancel: "Cancelar",
      none: "Ninguno",
      saved: "Días de descanso actualizados",
    },
    quests: {
      title: "Retos de hoy",
      subtitle: "Completa retos y gana XP",
      claim: "Reclamar",
      claimed: "Reclamado",
      allDone: "¡Todos los retos completados! Eres una estrella.",
      reward: "+{{xp}} XP",
      gained: "¡+{{xp}} XP ganados!",
      keys: {
        study_20: "Estudia 20 minutos",
        study_45: "Estudia 45 minutos",
        quiz_1: "Completa 1 cuestionario",
        ask_lumen_3: "Haz 3 preguntas a Lumen",
        create_1: "Crea 1 contenido de estudio",
        flashcards_deck: "Crea un mazo de tarjetas",
      },
    },
    onboarding: {
      intro: "¡Hola! Soy Lumen ✨ Te haré unas preguntas para crear tu ruta.",
      restTitle: "¿Cuándo descansas?",
      restSubtitle: "Elige tus días libres: esos días la racha está a salvo.",
    },
    tutor: { title: "Habla con Lumen", subtitle: "Tu tutor estrella, siempre contigo" },
  },
  fr: {
    name: "Lumen",
    tagline: "Ta petite étoile d'étude",
    level: "Niveau {{level}}",
    xpToNext: "{{xp}} XP jusqu'au niveau {{level}}",
    streak: {
      title: "Série d'étude",
      days_one: "{{count}} jour",
      days_other: "{{count}} jours",
      todayDone: "Tu as étudié aujourd'hui : série sauvée !",
      todayPending: "Étudie aujourd'hui pour garder ta série.",
      restToday: "Aujourd'hui c'est repos : ta série est protégée.",
      lost: "Série remise à zéro. On recommence !",
    },
    rest: {
      title: "Jours de repos",
      hint: "Les jours choisis, la série ne se perd pas.",
      edit: "Modifier",
      save: "Enregistrer",
      cancel: "Annuler",
      none: "Aucun",
      saved: "Jours de repos mis à jour",
    },
    quests: {
      title: "Défis du jour",
      subtitle: "Termine les défis et gagne des XP",
      claim: "Récupérer",
      claimed: "Récupéré",
      allDone: "Tous les défis réussis ! Tu es une étoile.",
      reward: "+{{xp}} XP",
      gained: "+{{xp}} XP gagnés !",
      keys: {
        study_20: "Étudie 20 minutes",
        study_45: "Étudie 45 minutes",
        quiz_1: "Termine 1 quiz",
        ask_lumen_3: "Pose 3 questions à Lumen",
        create_1: "Crée 1 contenu d'étude",
        flashcards_deck: "Crée un paquet de cartes",
      },
    },
    onboarding: {
      intro: "Salut ! Je suis Lumen ✨ Quelques questions pour créer ton parcours.",
      restTitle: "Quand te reposes-tu ?",
      restSubtitle: "Choisis tes jours libres : la série y est protégée.",
    },
    tutor: { title: "Parle avec Lumen", subtitle: "Ton tuteur étoile, toujours avec toi" },
  },
  de: {
    name: "Lumen",
    tagline: "Dein kleiner Lernstern",
    level: "Level {{level}}",
    xpToNext: "{{xp}} XP bis Level {{level}}",
    streak: {
      title: "Lernserie",
      days_one: "{{count}} Tag",
      days_other: "{{count}} Tage",
      todayDone: "Heute schon gelernt: Serie gesichert!",
      todayPending: "Lerne heute, damit die Serie bleibt.",
      restToday: "Heute ist Ruhetag: deine Serie ist geschützt.",
      lost: "Serie zurückgesetzt. Wir starten neu!",
    },
    rest: {
      title: "Ruhetage",
      hint: "An gewählten Tagen geht die Serie nicht verloren.",
      edit: "Bearbeiten",
      save: "Speichern",
      cancel: "Abbrechen",
      none: "Keine",
      saved: "Ruhetage aktualisiert",
    },
    quests: {
      title: "Heutige Challenges",
      subtitle: "Schließe Challenges ab und sammle XP",
      claim: "Einlösen",
      claimed: "Eingelöst",
      allDone: "Alle Challenges geschafft! Du bist ein Star.",
      reward: "+{{xp}} XP",
      gained: "+{{xp}} XP erhalten!",
      keys: {
        study_20: "20 Minuten lernen",
        study_45: "45 Minuten lernen",
        quiz_1: "1 Quiz abschließen",
        ask_lumen_3: "Stelle Lumen 3 Fragen",
        create_1: "Erstelle 1 Lerninhalt",
        flashcards_deck: "Erstelle ein Kartenset",
      },
    },
    onboarding: {
      intro: "Hi! Ich bin Lumen ✨ Ein paar Fragen für deinen Lernweg.",
      restTitle: "Wann ruhst du dich aus?",
      restSubtitle: "Wähle freie Tage: dann ist die Serie sicher.",
    },
    tutor: { title: "Sprich mit Lumen", subtitle: "Dein Sterntutor, immer dabei" },
  },
  pt: {
    name: "Lumen",
    tagline: "A tua estrelinha de estudo",
    level: "Nível {{level}}",
    xpToNext: "{{xp}} XP para o nível {{level}}",
    streak: {
      title: "Sequência de estudo",
      days_one: "{{count}} dia",
      days_other: "{{count}} dias",
      todayDone: "Já estudaste hoje: sequência segura!",
      todayPending: "Estuda hoje para não perder a sequência.",
      restToday: "Hoje é dia de descanso: a sequência está protegida.",
      lost: "Sequência reiniciada. Vamos recomeçar!",
    },
    rest: {
      title: "Dias de descanso",
      hint: "Nos dias escolhidos a sequência não se perde.",
      edit: "Editar",
      save: "Guardar",
      cancel: "Cancelar",
      none: "Nenhum",
      saved: "Dias de descanso atualizados",
    },
    quests: {
      title: "Desafios de hoje",
      subtitle: "Completa desafios e ganha XP",
      claim: "Resgatar",
      claimed: "Resgatado",
      allDone: "Todos os desafios concluídos! És uma estrela.",
      reward: "+{{xp}} XP",
      gained: "+{{xp}} XP ganhos!",
      keys: {
        study_20: "Estuda 20 minutos",
        study_45: "Estuda 45 minutos",
        quiz_1: "Completa 1 questionário",
        ask_lumen_3: "Faz 3 perguntas ao Lumen",
        create_1: "Cria 1 conteúdo de estudo",
        flashcards_deck: "Cria um baralho de cartões",
      },
    },
    onboarding: {
      intro: "Olá! Sou o Lumen ✨ Vou fazer algumas perguntas para criar o teu percurso.",
      restTitle: "Quando descansas?",
      restSubtitle: "Escolhe os dias livres: nesses dias a sequência está segura.",
    },
    tutor: { title: "Fala com o Lumen", subtitle: "O teu tutor estrela, sempre contigo" },
  },
};
